import { j as o } from "./AccesRecoveryIcon-CUPieIxT.js";
const r = () => /* @__PURE__ */ o.jsxs("svg", { viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ o.jsx(
    "path",
    {
      d: "M15.535 4.6h-.933v-4h-11.2v4h-.934C1.442 4.6.602 5.32.602 6.2v9.6c0 .88.84 1.6 1.866 1.6h13.067c1.027 0 1.867-.72 1.867-1.6V6.2c0-.88-.84-1.6-1.867-1.6M5.268 2.2h7.467v2.4H5.268zM9.002 15c-2.576 0-4.667-1.792-4.667-4s2.09-4 4.667-4 4.666 1.792 4.666 4-2.09 4-4.666 4",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ o.jsx("path", { d: "M9.546 9H8.457v2.53l1.786 1.53.773-.663-1.47-1.26z", fill: "currentColor" })
] });
export {
  r as T
};
